// @ts-check
/**
 * 每日口语 API — the daily quiz's spoken section.
 *
 * Rollout is server-side: a student off the list gets `{ enabled: false }` from
 * the GET, so nothing here (or in the UI) knows about student ids.
 */
import { apiRequest } from '../../../shared/api/base';

/**
 * @typedef {import('../../../shared/api/types').DailySpeakingResponse} DailySpeakingResponse
 * @typedef {import('../../../shared/api/types').DailySpeakingDisabledResponse} DailySpeakingDisabledResponse
 * @typedef {import('../../../shared/api/types').DailySpeakingPrompts} DailySpeakingPrompt
 * @typedef {import('../../../shared/api/types').DailySpeakingAnswerRequest} DailySpeakingAnswerRequest
 * @typedef {import('../../../shared/api/types').DailySpeakingAnswerResponse} DailySpeakingAnswerResponse
 */

/**
 * Today's three prompts. Always check `enabled` before reading `prompts`.
 *
 * @param {string} studentId
 * @param {string} [date] - 'YYYY-MM-DD'; the server only serves today (China)
 * @returns {Promise<DailySpeakingResponse | DailySpeakingDisabledResponse>}
 */
export function getDailySpeaking(studentId, date) {
  const q = date ? `?date=${encodeURIComponent(date)}` : '';
  return apiRequest(`/students/${encodeURIComponent(studentId)}/daily-speaking${q}`);
}

/**
 * Grade one spoken answer. Sends the RECORDING — the server transcribes it — and
 * no attempt number: the server counts attempts itself.
 *
 * @param {string} studentId
 * @param {DailySpeakingAnswerRequest} answer
 * @returns {Promise<DailySpeakingAnswerResponse>}
 */
export function submitDailySpeakingAnswer(studentId, answer) {
  return apiRequest(`/students/${encodeURIComponent(studentId)}/daily-speaking/answers`, {
    method: 'POST',
    body: JSON.stringify(answer),
  });
}
